export default {"src":"/_next/static/media/bitcoinLogo.612b73f8.svg","height":64,"width":64};